import { render } from "./OrgProfileNewsList.vue?vue&type=template&id=4878cfa6"
import script from "./OrgProfileNewsList.vue?vue&type=script&lang=js"
export * from "./OrgProfileNewsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__